import { render, staticRenderFns } from "./LabStatusHistory.vue?vue&type=template&id=6694793a&scoped=true"
import script from "./LabStatusHistory.vue?vue&type=script&lang=js"
export * from "./LabStatusHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6694793a",
  null
  
)

export default component.exports